// src/components/common/aia/tours/managerTours.js
export const managerTours = [
    {
        id: 'manager-welcome-tour',
        title: 'Welcome to Manager Portal',
        role: 'manager',
        autoStart: true,
        steps: [
            {
                target: null,
                title: 'Welcome to Manager Portal! 👔',
                content: "Hello! As a manager, you have access to powerful tools to lead your team effectively. Let me show you the key features that will help you manage your team's attendance, leave requests, and performance.",
                position: 'bottom'
            },
            {
                target: '.tour-manager-dashboard',
                title: 'Your Team Overview',
                content: 'Here\'s your team at a glance! See who\'s present, on leave, working from home, or absent today. You can also view team statistics, upcoming leaves, and recent activities all in one place.',
                position: 'right'
            },
            {
                target: '.tour-manager-team-approvals',
                title: 'Approve Leave Requests',
                content: 'Team members requesting leave? Review and approve or reject leave requests here. You can see leave details, team leave calendar, and manage multiple requests efficiently.',
                position: 'right'
            },
            {
                target: '.tour-manager-team-attendance',
                title: 'Review Team Attendance',
                content: 'Monitor your team\'s attendance patterns. View daily attendance, identify irregularities, review regularization requests, and generate attendance reports for your team.',
                position: 'right'
            },
            {
                target: null,
                title: 'Ready to Lead! 🚀',
                content: "You're all set to manage your team effectively! Remember, you can always access these features from the sidebar. Need help? Just click my avatar anytime. Let's build a great team together!",
                position: 'bottom'
            }
        ]
    },
    {
        id: 'manager-team-tour',
        title: 'Team Management',
        role: 'manager',
        autoStart: false,
        steps: [
            {
                target: '.tour-manager-team-performance',
                title: 'Team Performance',
                content: 'Track your team\'s performance goals, review cycles, and feedback. View individual performance metrics and team analytics to help your team grow.',
                position: 'right'
            },
            {
                target: '.tour-manager-team-management',
                title: 'Team Management',
                content: 'View and manage your team members. Access individual profiles, see contact information, and manage team structure.',
                position: 'right'
            }
        ]
    },
    {
        id: 'manager-reports-tour',
        title: 'Reports & Analytics',
        role: 'manager',
        autoStart: false,
        steps: [
            {
                target: '.tour-manager-team-reports',
                title: 'Reports & Analytics',
                content: 'Data-driven decisions made easy! Generate reports on team attendance, leave trends, overtime, and more. Export reports for presentations and meetings.',
                position: 'right'
            }
        ]
    }
];

export const getManagerTour = (tourId) => {
    return managerTours.find(tour => tour.id === tourId);
};

export const getAllManagerTours = () => managerTours;
